import { GenericTryOrthomosaicsModal } from "./GenericTryOrthomosaicsModal"

export const WelcomeTryOrthomosaicsModal = () => (
    <GenericTryOrthomosaicsModal supportsBack={false} />
)
